module.exports = __webpack_public_path__ + "static/media/table.da16cf82.png";